import { render, staticRenderFns } from "./PreviewTabbar.vue?vue&type=template&id=3a50f9ce&scoped=true"
import script from "./PreviewTabbar.vue?vue&type=script&lang=js"
export * from "./PreviewTabbar.vue?vue&type=script&lang=js"
import style0 from "./PreviewTabbar.vue?vue&type=style&index=0&id=3a50f9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50f9ce",
  null
  
)

export default component.exports